<template>
	<div  class="pageArea">
		<Head2></Head2>
		<div class="mainAea">
			<div class="sortTitle">{{$t('pages.appraisal.breadcrumb')}}</div>
			<div class="title">{{$t('pages.appraisal.title')}}</div>
			<div class="orerNum">{{$t('pages.appraisal.platform_order_no')}}{{orderInfo.order_no}}<span>|</span>{{$t('pages.appraisal.order_time')}}{{orderInfo.gmt_order}}</div>
			<div class="card" v-for="(item, index) in orderInfo.detail_list" :key="index">
				<div class="cardLeft">
					<img src="../assets/images/peoImg2.png"/>
					<div class="proTitle">{{item.product_name}}</div>
					<div class="proType">{{item.cate_name}}</div>
					<div class="proNum">
						{{item.sku_text}}
					</div>
				</div>
				<div class="cardRight">
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.appraisal.evaluation_time')}}</div>
						<div class="cardRi">{{item.gmt_eva}}</div>
					</div>
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.appraisal.product_score')}}</div>
						<div  class="cardRi">
							<Rate :max='5' :selected="item.score" :read-only="true"></Rate>
							<span>{{$t('pages.appraisal.score_format',{ score: item.score })}}</span>
						</div>
					</div>
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.appraisal.evaluation_content')}}</div>
						<div  class="cardRi">{{item.content}}</div>
					</div>
					<div class="cardli">
						<div class="cardLiText">{{$t('pages.appraisal.share_images')}}</div>
						<div class="cardRi">
							<img  :src="image" v-for="(image, index) in JSON.parse(item.eva_images)"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot2></Foot2>
	</div>
</template>

<script>
	import Head2 from '../components/head2.vue';
	import Foot2 from '../components/foot2.vue';
	import Rate from '../components/rate.vue';
	export default{
		components:{
			Head2,
			Foot2,
			Rate
		},
		data(){
			return{
				rating: 0,
				editableRating: 0,
				orderId:0,
				orderInfo:{},
				formInfo:[],
				isAnony:0,
			}
		},created(){
			this.orderId=this.$route.query.id;
			this.getOrderInfo();
		},
		methods:{
			getOrderInfo()
			{
				this.$scUtil.axiosPost(this, 'OrderApi/GetOrderInfo', {
					orderId: this.orderId,
					userName: localStorage.getItem('username'),
				}, res => {
					if (res.code == 100) {
						this.orderInfo = res.data[0];
					}
					else
					{
						 this.$message(res.message);
						 this.$router.push({ name: "myVue" });
					}
				
				});
			}
			
		}
	}
</script>

<style scoped>
	.pageArea{
		background-color: #ebecee;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.mainAea{
		width: 1200px;
	}
	
	.sortTitle{
		font-size: 13px;
		color: #333333;
		height: 44px;
		line-height: 44px;
	}
	
	.title{
		font-size: 18px;
		color: #000000;
		margin-top: 20px;
		width: 100%;
		text-align: center;
	}
	
	.orerNum{
		font-size: 13px;
		color: #000000;
		margin-top: 20px;
		width: 100%;
		text-align: center;
		margin-bottom: 30px;
	}
	
	.orderNum span{
		color: #666;
		margin: 0 30px;
	}
	
	.card{
		width: 1200px;
		background-color: #fff;
		display:flex;
		margin-bottom: 20px;
	}
	
	.cardLeft{
		width: 324px;
		border-right: 1px solid #e2e2e2;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 80px 30px 80px;
		box-sizing: border-box;
	}
	
	.cardLeft img{
		width: 105px;
		height: 105px;
		border: 1px solid #e6e6e6;
		margin-top: 58px;
	}
	
	.proTitle{
		font-size: 13px;
		color: #000000;
		text-align: center;
		margin-top: 24px;
		line-height: 25px;
	}
	
	.proType{
		font-size: 12px;
		color: #000000;
		text-align: center;
		margin-top: 15px;
	}
	
	.proNum{
		font-size: 12px;
		color: #888888;
		text-align: center;
		margin-top: 20px;
	}
	
	.cardRight{
		padding:40px 40px 0 40px;
		box-sizing: border-box;
		flex: 1;
	}
	
	.cardli{
		display: flex;
		align-items: flex-start;
		margin-bottom: 20px;
	}
	
	.cardLiText{
		width: 115px;
		min-width: 115px;
		text-align: left;
		font-size: 13px;
		color: #000000;
	}
	
	.cardRi{
		color: #000000;
		font-size: 13px;
		display: flex;
		line-height: 30px;
		flex-wrap: wrap;
		align-items: center;
	}
	
	.cardRi span{
		padding-bottom: 10px;
		margin-left: 10px;
	}
	
	.cardRi img{
		width: 50px;
		height: 50px;
		border: 1px solid #e2e2e2;
		margin:0 11px 11px 0;
	}
</style>